"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var FilterButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterButton, _PureComponent);

  function FilterButton() {
    (0, _classCallCheck2.default)(this, FilterButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterButton).apply(this, arguments));
  }

  (0, _createClass2.default)(FilterButton, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          disabled = _this$props.disabled,
          _onClick = _this$props.onClick;
      return _react.default.createElement(_UIButton.default, {
        disabled: disabled,
        use: "link",
        onClick: function onClick() {
          return _onClick();
        }
      }, _react.default.createElement(_UIIcon.default, {
        name: 'add'
      }), _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey(label)
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        label: _react.PropTypes.string,
        disabled: _react.PropTypes.bool,
        onClick: _react.PropTypes.func.isRequired
      };
    }
  }]);
  return FilterButton;
}(_react.PureComponent);

exports.default = FilterButton;
module.exports = exports.default;